import { COMMENT_INDICATOR_IDENTIFIER } from 'collaboration-sidebar/constants/identifiers';
import { memo } from 'react';
import styled from 'styled-components';
import EmbeddedCommentIndicator from './EmbeddedCommentIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
const PositionedEmbeddedComment = styled.div.attrs(({
  iconPosition
}) => ({
  style: iconPosition
})).withConfig({
  displayName: "EmbeddedComment__PositionedEmbeddedComment",
  componentId: "sc-182vvkx-0"
})([".hs-private.hs-private.hs-private &{position:absolute;", ";}"], ({
  leftOffset,
  topOffset
}) => `
    left: ${leftOffset}px;
    top: ${topOffset}px;
  `);
function EmbeddedComment({
  onClose,
  collaborationSidebarState,
  verticalPositioning,
  setIsCommenting,
  iconPosition = {},
  iconProps,
  moduleParentComment,
  topOffset,
  leftOffset,
  isOpen,
  embeddedCommentWrapperRef,
  toggleOpenPopover
}) {
  return /*#__PURE__*/_jsx(PositionedEmbeddedComment, {
    id: COMMENT_INDICATOR_IDENTIFIER,
    topOffset: topOffset,
    leftOffset: leftOffset,
    iconPosition: iconPosition,
    children: /*#__PURE__*/_jsx(EmbeddedCommentIndicator, {
      collaborationSidebarState: collaborationSidebarState,
      isOpen: isOpen,
      onClose: onClose,
      iconProps: iconProps,
      setIsCommenting: setIsCommenting,
      verticalPositioning: verticalPositioning,
      hasCustomPosition: Object.keys(iconPosition).length > 0,
      moduleParentComment: moduleParentComment,
      embeddedCommentWrapperRef: embeddedCommentWrapperRef,
      toggleOpenPopover: toggleOpenPopover
    })
  });
}
export default /*#__PURE__*/memo(EmbeddedComment);